import { motion } from 'motion/react'
import styled from 'styled-components'

export const Container = styled.div`
  display: flex;
  flex-direction: column;
  max-height: 500px;
  overflow-y: auto;
`

export const CarrierContainer = styled.div`
  display: flex;
  gap: ${props => props.theme.spacing.sp8};
  padding: ${props => props.theme.spacing.sp8};
  border-radius: ${props => props.theme.primitives.radius.radius2};

  &:hover {
    background-color: ${props => props.theme.colors.disabled.surface};
  }
`

export const CarrierPosition = styled.div`
  display: flex;
  align-items: center;
  justify-content: center;
  padding: ${props => props.theme.spacing.sp16};
  width: ${props => props.theme.size.S};
`

export const CarrierInfoContainer = styled.div`
  display: flex;
  flex-direction: column;
  gap: ${props => props.theme.spacing.sp8};
  width: 100%;
`

export const CarrierLogo = styled.img`
  width: ${props => props.theme.size.S};
  height: ${props => props.theme.size.S};
  aspect-ratio: 1;
  object-fit: contain;
`

export const CarrierName = styled.div`
  display: flex;
  align-items: center;
  gap: ${props => props.theme.spacing.sp8};
`

export const ProgressBarContainer = styled.div`
  display: flex;
  align-items: center;
  gap: ${props => props.theme.spacing.sp8};
`

export const ProgressBar = styled(motion.div)`
  width: 0%;
  height: ${props => props.theme.size.XXS};
  background-color: ${props => props.theme.colors.danger.surface};
  position: relative;
  border-radius: ${props => props.theme.primitives.radius.radius2};
`

export const DeliveryTimeContainer = styled.div`
  width: 100px;
`
